import { AfterViewInit, DestroyRef, Directive, ElementRef, inject } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { onResize } from '@coin/shared/core/util-helpers';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { animationFrames, debounce, startWith } from 'rxjs';

/** Enables or disables matTooltip if the attached element has ellipsis overflow and sets the content to the text content.
 * @example `<p class="overflow-ellipsis" coinEllipsisTooltip matTooltip> Hello World! </p>`
 * */
@Directive({
  selector: '[coinEllipsisTooltip][matTooltip]',
  standalone: true
})
export class EllipsisTooltipDirective implements AfterViewInit {
  private readonly matTooltip = inject(MatTooltip);
  private readonly elem = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly destroyRef = inject(DestroyRef);

  public ngAfterViewInit(): void {
    onResize(this.elem.nativeElement)
      .pipe(
        startWith(null),
        debounce(() => animationFrames()),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this.matTooltip.disabled = !isEllipsisActive(this.elem.nativeElement);
        this.matTooltip.message = this.elem.nativeElement.textContent;
      });
  }
}

function isEllipsisActive(element: HTMLElement): boolean {
  return element.offsetWidth < element.scrollWidth || element.offsetHeight < element.scrollHeight;
}
